export default function(state={}, action){
  switch(action.type) {
    case 'ADD_SPECIFIC_FB':
        return {...state, newFeedback:action.paylod}
    case 'GET_FEEDBACK_SPECIFIC':
      return {...state, newFeedback:null,deleteSpecificFeedback:null, specific:action.paylod}
    case 'GET_FEEDBACK_MOTIVATION':
      return {...state,newFeedback:null, motivation:action.paylod}
    case 'ADD_MOTIVATION_FB':
      return {...state, newFeedback:action.paylod}
    case 'ADD_SPECIFIC_TO_PROD':
      return {...state, addSpecificToProd:action.paylod}
    case 'ADD_MOTIVATION_TO_PROD':
      return {...state, addMotivationToProd:action.paylod}
    case 'DELETE_SPECIFIC_FEEDBACKS':
      return {...state, deleteSpecificFeedback:action.paylod}
    default:
      return state;
  }
}